import store from "../../../store";
import user_buttons from './index.vue';

window.USER_BUTTONS =  new Vue({
	store,
	el: 'div#user_profile_buttons',
	name : "USER_BUTTONS",

	data () {
		return {

		}
	},
	created () {

	},
	components : {
		user_buttons,
	}
});
